export default {
  NEVER: -1,
  DAILY: 0,
  WEEKLY: 1,
  MONTHLY: 2,
};
